import { useState,useMemo } from 'react';
import { Skeleton, Table, TableBody, TableHead, TableRow, Paper, TableCell, TableContainer, TablePagination, TableSortLabel, Box, TextField, Divider, Typography } from '@mui/material';

import styles from './Table.module.scss'

export default function CustomTable({ columns, rows, Title='',rowsPerPage = -1 }) {
  const [page, setPage] = useState(0);
  const [rowsPerPageValue, setRowsPerPageValue] = useState(10);
  const [order, setOrder] = useState('asc');
  const [orderBy, setOrderBy] = useState('');
  const [searchText, setSearchText] = useState('');

  const handleRequestSort = (property) => {
    const isAscending = orderBy === property && order === 'asc';
    setOrder(isAscending ? 'desc' : 'asc');
    setOrderBy(property);
  };

  const handleChangePage = (e, pageIndex) => setPage(pageIndex);

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPageValue(+event.target.value);
    setPage(0);
  };

  const filteredRows = useMemo(() => {
    if (!searchText) return rows;
    return rows.filter((row) =>
      columns.some((column) => {
        const value = row[column.id];
        return value && value.toString().toLowerCase().includes(searchText.toLowerCase());
      })
    );
  }, [rows, searchText, columns]);


  const sortedRows = useMemo(() => {
    if (!orderBy) return filteredRows;
    return [...filteredRows].sort((a, b) => {
      const aValue = a[orderBy];
      const bValue = b[orderBy];
      if (aValue < bValue) return order === 'asc' ? -1 : 1;
      if (aValue > bValue) return order === 'asc' ? 1 : -1;
      return 0;
    });
  }, [filteredRows, orderBy, order]);


  // const sortedRows = useMemo(() => {
  //   if (!orderBy) return rows;
  //   return [...rows].sort((a, b) => {
  //     const aValue = a[orderBy];
  //     const bValue = b[orderBy];
  //     if (aValue < bValue) return order === 'asc' ? -1 : 1;
  //     if (aValue > bValue) return order === 'asc' ? 1 : -1;
  //     return 0;
  //   });
  // }, [rows, orderBy, order]);
  
  
  return (
    <Paper sx={{ overflow: 'hidden' }}>
      <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            padding:'10px'
          }}
        >
          <Typography variant='h3' style={{fontWeight:'bold'}}>{Title}</Typography>
          <TextField
            variant="outlined"
            size="small"
            placeholder="Search..."
            value={searchText}
            onChange={(e) => setSearchText(e.target.value)}
            sx={{ width: '200px',border:'1px solid yellow',borderRadius:'7.5px' }}
          />
        </Box>
        <Divider />
      {rows?.length ? (
        <>
          <TableContainer sx={{ maxHeight: '400px' }}>
            <Table stickyHeader aria-label="sticky table" >
              <TableHead classes={{root:styles['root-header']}}>
                <TableRow classes={{root:styles['root-header']}}>
                  {columns.map((column) => (
                    <TableCell
                      classes={{root:styles['root-header']}}
                      key={`head-${column.id}`}
                      // sx={{ whiteSpace: 'nowrap'}}
                      align="center"
                      sortDirection={orderBy === column.id ? order : false}
                      // style={{ minWidth: column.minWidth }}// Ensure a minimum width for each column
                    >
                      <TableSortLabel
                        active={orderBy === column.id}
                        direction={orderBy === column.id ? order : 'asc'}
                        onClick={() => handleRequestSort(column.id)}
                      >
                        {column.label}
                      </TableSortLabel>
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {sortedRows
                  .filter((_, index) =>
                    rowsPerPageValue !== -1
                      ? page * rowsPerPageValue <= index && index < page * rowsPerPageValue + rowsPerPageValue
                      : true
                  )
                  .map((row, index) => {
                    return (
                      <TableRow key={`table-row-${index}`} classes={{root:styles['root-row']}}>
                        {columns.map((column) => {
                          const value = row[column.id];
                          return (
                            <TableCell
                              key={`table-cell-${column.id}-${index}`}
                              align="center"
                              // sx={{ whiteSpace: 'nowrap'}} // Prevents text from wrapping
                            >
                              {column.format && typeof value === column.type
                                ? column.format(value)
                                : value}
                            </TableCell>
                          );
                        })}
                      </TableRow>
                    );
                  })}
              </TableBody>
            </Table>
          </TableContainer>
            <TablePagination
              rowsPerPageOptions={[10,20,50,100]}
              component="div"
              count={sortedRows.length}
              rowsPerPage={rowsPerPageValue}
              page={page}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
            />
        </>
      ) : (
        <Skeleton variant="rect" width="100%" height={150} />
      )}
    </Paper>
  );
}
